import React, { useState, useEffect } from 'react';
import {
  Box,
  Autocomplete,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import CustomCard from '../../components/UIComponents/CustomCard';
import CustomTypography from '../../components/UIComponents/CustomTypography';
import theme from '../../assets/theme/index';
import CustomButton from "../../components/UIComponents/CustomButton";
import TariffRow from './components/TariffRow';
import HeaderComponent from '../../components/Header';
import { fetchRoomTypes } from '../../service/network';
import StyledAutocomplete from '../../components/UIComponents/StyledAutocomplete';
import StyledTextField from '../../components/UIComponents/StyledTextField';

export default function TarifChart() {
  const [filters, setFilters] = useState({
    roomType: '',
    status: '',
    searchQuery: ''
  });
  const [showNewPackageForm, setShowNewPackageForm] = useState(false);
  const [roomTypeOptions, setRoomTypeOptions] = useState([]);
  const [statusOptions] = useState(['Active', 'Inactive']);

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    const loadRoomTypes = async () => {
      try {
        const params = {
          doctype: 'Room Type',
          fields: JSON.stringify(["name", "room_type"])
        };
        const res = await fetchRoomTypes(params);
        const roomTypes = res.data.message.values.map(item => item[1]);
        setRoomTypeOptions([...new Set(roomTypes)]);
      } catch (err) {
        console.error("Failed to fetch room types", err);
      }
    };

    loadRoomTypes();
  }, []);

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <HeaderComponent title="Tariff Chart" />

      <CustomCard bgColor="light" shadow="lg" borderRadius="xxl" sx={{
        width: '100%', minHeight: 800, p: 3, borderTopLeftRadius: 0,
      }}>
        {/* Grid Row for Inputs */}
        <Grid container spacing={1} alignItems="flex-end">

          {/* Search Bar */}
          <Grid size={3}>
            <StyledTextField
              label="Search"
              placeholder="Search by Name or ID"
              value={filters.searchQuery}
              onChange={(e) => handleFilterChange('searchQuery', e.target.value)}
            />
          </Grid>

          {/* Status */}
          <Grid size={2}>
            <StyledAutocomplete
              label="Status"
              options={statusOptions}
              value={filters.status}
              onChange={(e, newValue) => handleFilterChange('status', newValue)}
            />
          </Grid>


          
          {/* Add New Package Button aligned right */}
          <Grid size={6}>
            <CustomButton
              variant="contained"
              color="light"
              sx={{
                borderRadius: theme.borderRadius.medium,
                minWidth: 160,
                height: 36,
                ml:2
              }}
              onClick={() => setShowNewPackageForm(true)}
            >
              <Typography variant="subHeading" sx={{ textTransform: "none" }}>
                Add New Package
              </Typography>
            </CustomButton>
          </Grid>

        </Grid>

        <TariffRow
          showNewPackageForm={showNewPackageForm}
          setShowNewPackageForm={setShowNewPackageForm}
          filters={filters}
        />
      </CustomCard>
    </Box>
  );
}